import { ApplicationDocumentsScreen } from "@/interactors/ApplicationDocumentsScreen";

export default function Documents() {
  return <ApplicationDocumentsScreen />;
}
